<template>
<div class="page-wrapper personalized-sites-wrap">
    <div class="container-fluid">
        <breadcrumb :items="breadcrumbItems" />
        <div class="page-title">
            <h1>Personalized Sites</h1>
            <custom-button iconClass="fas fa-edit" @onClicked="editSite" />
        </div>
        <div class="row personalized-sites">
            <PersonalizedSiteTable :rows="rows"/>
        </div>
    </div>
        <PersonalizedSiteEdit 
        :webAccessCode="webAccessCode"
        :updateUrl="updateLandingPageUrl"
        @onSuccess="getSites"
    />
</div>

</template>

<script>
import PersonalizedSiteTable from './partials/PersonalizedSiteTable.vue';
// import PersonalizedSiteEdit from '../Dashboard/partials/PersonalizedSiteEdit.vue';
import PersonalizedSiteEdit from '../Dashboard/partials/PersonalizedSiteEdit.vue';
// import PlaceHolderimg from '../../assets/logo.png'
import Api from "@/resource/Api";
export default {
    name: "PersonalizedSites",
    components: {
        PersonalizedSiteTable,
        PersonalizedSiteEdit
    },
    data: () => ({
        breadcrumbItems: [{ title: "Personalized Sites", active: true }],
                rows: [],
        webAccessCode: "",
        updateLandingPageUrl: "v2/update-personalized-site"
    }),
    methods: {
        editSite() {
            this.$bvModal.show("updatePersonalizedSite");
        },
      getSites() {
          Api.get("v2/get-personalized-site")
            .then((res) => {
              let data = res.data.data;
              this.rows = data.sites;
              this.webAccessCode = data.web_access_code;
            })
            .catch(() => {
              this.sites = [];
              this.webAccessCode = "";
            });
        },      
    },
    mounted() {
        this.getSites();
    }
}
</script>
<style src="../../assets/css/personalized-sites.css"></style>
<style scoped>
.personalized-sites{
    border-radius: 10px;
    padding: 1.5rem 0.5rem ;
    background:#fff;
}
.personalized-sites-wrap .page-title{
    margin-bottom: 1.5rem;
}
.personalized-sites-wrap #updatePersonalizedSite___BV_modal_content_ h4{
    font-size: 20px;
    color: #2C3F58;
    font-weight: 600;
    margin: 0;
}
.page-title{
    justify-content: start;
}
.page-title h1 {
margin-right: 0.75rem;
}
</style>